import { getEventMeta, getFormattedEventTimeSlots, hasMeta } from '@/utils/events.utils'
import TXT from '@/messages'
import { useSeller } from '@/app/_providers/SellerProvider/SellerProvider'
import { useEvent } from '@/app/_providers/EventProvider/EventProvider'
import { composeTheme } from '@css-modules-theme/core'
import sharedEventStyles from '@/styles/templates/Events.module.css'
import eventStyles from '@/app/_components/EventHeader/EventHeader.module.css'
import classNames from 'classnames'
import { ReactNode } from 'react'

const DateAndTime = (): ReactNode => {
  const { timezone } = useSeller()
  const event = useEvent<Transformed.EventWithTimeslotsAndMeta>()
  const meta = getEventMeta(event.meta)
  const {
    formattedTime,
    formattedDate,
  } = getFormattedEventTimeSlots(event.timeslots, timezone, meta, 'details')
  const styles = composeTheme([
    { theme: sharedEventStyles },
    { theme: eventStyles },
  ])
  return (
    <>
      <div className={eventStyles.DateTime} data-testid="formatted-date-time">
        <span className={styles.EventCategoryHeader} data-testid="formatted-date">{formattedDate}</span>
        {' '}
        {formattedTime && (
          <>
            <span
              data-testid="formatted-time"
              className={classNames(
                styles.EventTime,
                styles.EventCategoryHeader,
              )}
            >
              {formattedTime}
            </span>
            <div className={styles.EventAgeRestriction}>
              {TXT.events.eventAge}
              {' '}
              {hasMeta('eventAge', meta) ? meta.eventAge : TXT.events.eventAllAges}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default DateAndTime
